import { Grid, Typography, Button } from "@mui/material";
import { useRef } from "react";
import { toast } from "react-toastify";

interface IItemProps {
	label: string;
	source: string;
	onUpdate: any;
	onDelete?: any;
}
const Item = (props: IItemProps) => {
	const { label, source, onUpdate, onDelete } = props;
	const fileInputRef = useRef<HTMLInputElement>(null);

	const handleButtonClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const handleFileChange = (event: any) => {
		const file = event.target.files[0];

		if (file) {
			if (file.type.startsWith("image/")) {
				onUpdate(file);
			} else {
				toast.warn("Por favor, selecciona un archivo de imagen.");
			}
		}
	};

	return (
		<Grid item md={3} xs={12} style={{ padding: "16px" }}>
			<Grid item>
				{/* alto fijo para que todas las tarjetas queden alineadas
				    aunque el nombre ocupe una o dos líneas */}
				<Typography
					variant="subtitle1"
					fontWeight={700}
					textAlign="center"
					sx={{ minHeight: 52 }}
				>
					{label || ""}
				</Typography>

				<img
					style={{
						width: "100%",
						height: 160,
						objectFit: "contain",
						background: "#f1f1f1",
						borderRadius: 8,
						marginBottom: 8,
					}}
					src={source || "https://placehold.jp/300x300.png"}
					alt={label}
				/>
				<input
					type="file"
					onChange={handleFileChange}
					style={{ display: "none" }}
					ref={fileInputRef}
				/>

				<Button
					fullWidth
					variant="contained"
					onClick={handleButtonClick}
				>
					Reemplazar imagen
				</Button>
				{onDelete && source && (
					<Button
						fullWidth
						variant="contained"
						color="secondary"
						onClick={onDelete}
						style={{ marginTop: "10px" }}
					>
						Eliminar imagen
					</Button>
				)}
			</Grid>
		</Grid>
	);
};

export default Item;
